// Lo mismo que valida el backend, para avisar antes de mandar (el backend es el que decide).
export const MAX_NOMBRE = 60;

/** Si el cliente pega "www.sitio.com" le sumamos https:// (lo más común); http:// se rechaza. */
export function completarUrl(v) {
  const s = String(v || '').trim();
  if (!s) return s;
  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) return s;
  return `https://${s.replace(/^\/+/, '')}`;
}

export function errorUrl(v) {
  const s = completarUrl(v);
  if (!s) return 'Pegá la dirección del link';
  let u;
  try {
    u = new URL(s);
  } catch (e) {
    return 'La dirección no es válida';
  }
  if (u.protocol !== 'https:') return 'La dirección tiene que empezar con https://';
  if (u.username || u.password) return 'La dirección no puede llevar usuario ni contraseña';
  if (!u.hostname.includes('.') || u.hostname === 'localhost') return 'Esa dirección no es pública';
  return null;
}

export function errorNombre(v) {
  const n = String(v || '').replace(/\s+/g, ' ').trim();
  if (!n) return 'Poné un nombre para el link';
  if (n.length > MAX_NOMBRE) return `Hasta ${MAX_NOMBRE} caracteres`;
  return null;
}

/** Texto corto del sitio para mostrar debajo del nombre (sin https:// ni www.). */
export function dominio(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch (e) {
    return url;
  }
}
